<template>
  <span class="text-style-xs text-tertiary flex gap-2 items-center">
    {{ formattedDate }}
  </span>
</template>

<script setup>
import {
  differenceInMinutes,
  isThisHour,
  isToday,
  isYesterday,
} from "date-fns";
import { localizedFormat } from "@/Utils/date";
import { computed, defineProps } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  date: Date,
  relative: Boolean,
  locale: String,
});

const formattedDate = computed(() => {
  if (props.relative) {
    const currentDate = new Date();

    if (differenceInMinutes(currentDate, props.date) === 0) {
      return `${t("components.time_ago.just_now")}`;
    }

    if (isThisHour(props.date)) {
      return `${differenceInMinutes(currentDate, props.date)} ${t(
        "components.time_ago.minutes_ago"
      )}`;
    }

    if (isToday(props.date)) {
      return `${t("components.time_ago.today")} ${format("p")}`;
    }

    if (isYesterday(props.date)) {
      return `${t("components.time_ago.yesterday")} ${format("p")}`;
    }
  }

  return format("MMM dd, yyyy, hh:mm a");
});

const format = (format) => {
  return localizedFormat(props.date, format, props.locale);
};
</script>
